export default [
  {
    path: '/integrations',
    redirect: '/company-settings/integrations',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/integrations/slack',
    redirect: '/company-settings/integrations',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/integrations/slack/authorise',
    name: 'IntegrationsSlackAuthorise',
    component: () => import('@/components/pages/integrations/slack/AuthorisePage.vue'),
    meta: {
      title: 'integrations.slack_authorise',
      requiresAuth: true,
    },
  },
];
